import { Injector, Injectable } from '@angular/core';
import { BitfApiService } from '@bitf/core/services/api/bitf-api.service';

@Injectable({ providedIn: 'root' })
export class FoodProductService extends BitfApiService {
  constructor(protected injector: Injector) {
    super('food-product', injector);
  }
}
